import React from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Colors } from '../../../../scss/common/style';

import ErrorLabel from '../ErrorLabel';
import { transformLabels } from '../../../../utils/misc';

interface Option {
  label: string;
  value: string | number;
  color?: string;
}

interface ButtonGroupComponentProps {
  onChange: (value: string | number) => void;
  name: string;
  initialValue?: string | number;
  options: Option[];
  cols?: number;
  label?: string;
  touched?: Record<string, boolean>;
  errors?: Record<string, string>;
  buttonsPerRow?: number;
}

export default function ButtonGroupComponent({
  onChange,
  name,
  initialValue = '',
  options,
  cols = 6,
  label = '',
  touched = {},
  errors = {},
  buttonsPerRow = 5,
}: ButtonGroupComponentProps): JSX.Element {
  return (
    <div className={`form-group col-sm-${cols}`}>
      <TiitleButtons className="ak-form-labels" htmlFor={`id-${name}`}>
        {label || transformLabels(name)}
      </TiitleButtons>
      <ToggleButtonGroupS
        style={{ width: '100%', flexWrap: 'wrap' }}
        id={`id-${name}`}
        aria-label={`Choice of ${name}`}
        type="radio"
        name={name}
        onChange={onChange}
        defaultValue={initialValue}
      >
        {options.map((item, i) => {
          return (
            <ToggleButton
              style={{
                width: `${100 / buttonsPerRow}%`,
                backgroundColor: item.color,
                borderColor: item.color,
                color: item.DarkText ? '#000' : '#fff',
              }}
              key={`${item.value}`}
              id={i}
              value={item.value}
            >
              {item.label}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroupS>
      {touched && touched[name] && errors[name] && <ErrorLabel error={errors[name]} />}
    </div>
  );
}

const TiitleButtons = styled.label`
  color: ${Colors.darkBrown}!important;
`;

const ToggleButtonGroupS = styled(ToggleButtonGroup)`
label {
  display: flex;
  align-items: center;
  justify-content: center;
  border 1px solid #f4f4f4;;
  background: #fff;
  color:${Colors.darkBrown}!important;
  height: 58px;
  width: 63px!important;
}
label:hover {
  background: #EEEEEE!important;
  border-color: #EEEEEE!important;
  color:${Colors.darkBrown}!important
}
  .active {
    background: ${Colors.darkBrown}!important;
    border-color: ${Colors.darkBrown}!important;
    color:#fff!important;
}

  }
  &.btn-primary {
    background: red !important;
  }
`;
